module.exports = __webpack_public_path__ + "img/A13c_2.G.1.3-GR7a.16042cf7.jpg";